import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { TitleCasePipe } from '@angular/common';
import { AutoCapitalizePipe } from '../../pipes/auto-capitalize.pipe';

@Component({
  selector: 'app-footer',
  imports: [TranslateModule, RouterLink, TitleCasePipe, AutoCapitalizePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  socials: { name: string; url: string; icon: string }[] = [
    {
      name: 'Discord',
      url: environment.socials.discord_url,
      icon: 'assets/icons/discord.svg',
    },
    {
      name: 'Instagram',
      url: environment.socials.instagram_url,
      icon: 'assets/icons/instagram.svg',
    },
    {
      name: 'LinkedIn',
      url: environment.socials.linkedin_url,
      icon: 'assets/icons/linkedin.svg',
    },
  ];
}
